module.exports = __webpack_public_path__ + "img/tool00.fec3846a.png";